if (libraries.knockoutValidation) {
  ko.validation.rules.checked = {
    validator: function(value) {
      return !!ko.unwrap(value);
    },
    message: 'You must agree.'
  };
}
